import { z } from 'zod';
import { msg } from '@/lib/forms/messages';
import { maxCodePoints } from '@/lib/forms/primitives';

// One reviewed change row. Blankness mirrors ReviewedDesignChangeRequest._not_blank
// (api/routes/drbfm.py:337-348), which rejects any of the four on `.strip()`.
export const changeReviewRowSchema = z.object({
  // item_name VARCHAR(500) + LENGTH() CHECK — 038_gds_drbfm_case_workflow.sql:39,52
  // (identically in 017_drbfm_tables.sql:40,49). Postgres LENGTH() counts code points.
  // Cap measures the RAW value: handleSubmit posts `changes` verbatim, so trimming
  // first would validate a string nobody sends. Required still trims.
  itemName: z
    .string()
    .check(maxCodePoints(500, 'validation.maxLength'))
    .refine((value) => value.trim().length > 0, msg('validation.required')),
  // The other three are TEXT with no CHECK (038:40-42) — required, deliberately uncapped.
  changeDescription: z.string().trim().min(1, msg('validation.required')),
  oldSpecification: z.string().trim().min(1, msg('validation.required')),
  newSpecification: z.string().trim().min(1, msg('validation.required')),
});

export type ChangeReviewRowValues = z.infer<typeof changeReviewRowSchema>;
